<template>
  <popper trigger="clickToOpen"
          :options="{
      placement: 'right',
      modifiers: { offset: { offset: '0,10px' } }
    }">
    <div class="popper tooltip-inner" v-tooltip:right="text">
      {{text}}
    </div>


    <span class="help-trigger" style="cursor: pointer;" slot="reference">
      <i class="material-icons themed-icon">help_outline</i>
    </span>

  </popper>
</template>

<script>
  import 'bootstrap';
  import Popper from 'vue-popperjs';
  import 'vue-popperjs/dist/vue-popper.css';

  export default {
    props: ["text"],
    components: {
      'popper': Popper
    },
  }
</script>

<style>
</style>